import React, { useRef } from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';

import { useSectionViewTracking } from '../CustomHook/useSectionViewTracking';
import { LanguageLandingPage } from '../../../global-interfaces';
import s from './PreFooter.scss';
import { LanguageLandingPageFooterType } from '../../../../../api/public/static-pages-api';
import { SlLogin } from '../../../../../login/public/SlLogin/SlLogin';

export interface IPreFooterProps {
	data: LanguageLandingPageFooterType;
}

export function PreFooter({
	data: { title, signup },
}: IPreFooterProps): JSX.Element {
	useStyles(s);
	const element = useRef<HTMLElement>(null);

	useSectionViewTracking({
		ref: element,
		sectionName: LanguageLandingPage.PreFooter,
		sectionTitle: title,
	});

	return (
		<section
			className="sl-language__pre-footer"
			sl-test-data="cmpLanguagePreFooter"
			ref={element}
		>
			<div className="sl-language__pre-footer__title-wrapper">
				<h2 className="sl-language__pre-footer__title">{title}</h2>
			</div>
			<div className="sl-language__pre-footer__signup-wrapper">
				<SlLogin
					configs={{
						disableScrollToTop: true,
						isTitleH1: false,
					}}
					useRouter={false}
					defaultRoute="signup"
					signupTitle={signup?.title}
					cssClass="sl-language__signup"
					trackingPrefix="language-landing-page"
				/>
			</div>
		</section>
	);
}
